module.exports = __webpack_public_path__ + "img/tuts-rating-slider-mobile-5.ebe00c4d.png";